var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$route.name === _vm.$routes.ProjectContentGeneral)?_c('div',{staticClass:"space-y-8"},[_c('page-header',{attrs:{"hide-breadcrumbs":""}}),_c('bot-data-sources-list-card',{attrs:{"bot":_vm.bot}}),_c('bot-business-data-card',{attrs:{"bot":_vm.bot}})],1):_c('router-view',{staticClass:"space-y-8"})
}
var staticRenderFns = []

export { render, staticRenderFns }